import Flickity from "flickity";
import { gsap, ScrollTrigger } from "../global/gsap";

const initLatestNews = (latestNewsEls) => {
    latestNewsEls.forEach((el) => {
        const flickityOptions = {
            cellAlign: "left",
            wrapAround: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            setGallerySize: true,
            cellSelector: ".news-card",
            watchCSS: true,
            contain: true
        };

        const flkty = new Flickity(el, flickityOptions);
    });
};

export { initLatestNews as default };
